/** @jsx jsx */
import React from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';

const FlexBox: React.FC<{
  alignItems?: 'center'|'flex-start'|'flex-end'; // 適宜増やす
  direction?: 'row'|'column',
  justifyContent?: 'center'|'flex-start'|'flex-end'|'space-between'|'space-around',
  customStyle?: SerializedStyles
}> = ({
  children, customStyle, alignItems = 'center', direction = 'row', justifyContent
}) => (
  <div css={css({
    display: 'flex',
    alignItems,
    justifyContent: justifyContent,
    flexDirection: direction,
  }, customStyle)}
  >
    {children}
  </div>
);

export default FlexBox;
